import React, { FC, useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import uploadIcon from '../../assets/paper_upload.svg';
import cancelIcon from '../../assets/cancel_button.svg';
import { pxToRem } from '../../utils/pxToRem';

interface IFilePicker {
  onFilePicked: (item: File[]) => void;
  initialValue?: Array<string>;
  multiple?: boolean;
  accept: string;
}

export const FilePicker: FC<IFilePicker> = ({
  onFilePicked,
  initialValue = [],
  multiple = false,
  accept
}) => {
  const imgRef = useRef<HTMLInputElement>(null);
  const [fileUpload, setFileUpload] = useState<File[]>();
  const [preview, setPreview] = useState<string[]>([...initialValue]);

  const handleImageChange: React.ChangeEventHandler<HTMLInputElement> = (e) => {
    if (e.target.files) {
      const files = e.target.files;
      setFileUpload(Array.from(files));
      onFilePicked(Array.from(files));
    } else {
      setFileUpload([]);
    }
  };

  useEffect(() => {
    setPreview([]);
    if (fileUpload) {
      fileUpload.forEach((file) => {
        setPreview((prev) => [...prev, file.name]);
      });
    }
  }, [fileUpload]);

  const handleImageClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    imgRef.current?.click();
  };

  const removeSelectedImage = () => {
    setPreview([]);
    setFileUpload([]);
    imgRef.current!.value = '';
  };
  return (
    <>
      <InputImage
        type="file"
        ref={imgRef}
        multiple={multiple}
        accept={accept}
        onChange={handleImageChange}
      />
      <ImageUploadContainer>
        {preview.length ? (
          <ViewImageUploadWrapper>
            <ImageDetails>
              {preview.map((name, index) => (
                <ImageFileName key={index}>{name}</ImageFileName>
              ))}
            </ImageDetails>
            <CancelImage
              src={cancelIcon}
              alt=""
              onClick={removeSelectedImage}
            />
          </ViewImageUploadWrapper>
        ) : (
          <ImageUploadWrapper>
            <ImageUploadPlaceholder onClick={handleImageClick}>
              <IconPlaceholder src={uploadIcon} />
              <PlaceholderHeading>Upload file</PlaceholderHeading>
              <PlaceholderCaption>
                File must be a <BoldText>.xlsx</BoldText> file ;
              </PlaceholderCaption>
            </ImageUploadPlaceholder>
          </ImageUploadWrapper>
        )}
      </ImageUploadContainer>
    </>
  );
};
const InputImage = styled.input`
  display: none;
`;
const ImageUploadContainer = styled.div``;
const ImageUploadWrapper = styled.div`
  border: 1px dashed #d6d6d6;
  box-sizing: border-box;
  border-radius: 6px;
  display: flex;
  height: 100px;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 15px;
  width: 100%;
`;

const ImageUploadPlaceholder = styled.div``;
const IconPlaceholder = styled.img``;
const PlaceholderHeading = styled.h6`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #32324b;
`;
const PlaceholderCaption = styled.p`
  font-size: ${pxToRem(12)};
  line-height: 120%;
  color: #a1a1a1;
`;

const ViewImageUploadWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px dashed #d6d6d6;
  box-sizing: border-box;
  border-radius: 6px;
  padding: 15px;
`;
const ImageDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const ImageFileName = styled.p`
  font-size: 16px;
  line-height: 140%;
  color: #32324b;
  margin: 0;
`;

const CancelImage = styled.img``;

const BoldText = styled.span`
  color: #32324b;
  font-weight: 500;
`;
